export default function StepProgress({ steps, current }) {
  return (
    <div className="space-y-2">
      {steps.map((s, i) => (
        <div
          key={i}
          className={`text-sm p-2 rounded-lg ${
            i < current ? "bg-green-100 line-through text-green-700" : i === current ? "bg-yellow-100" : ""
          }`}
        >
          {s}
        </div>
      ))}
    </div>
  );
}
